import { render } from "./Blackjack.vue?vue&type=template&id=a5b785a2&scoped=true"
import script from "./Blackjack.vue?vue&type=script&lang=js"
export * from "./Blackjack.vue?vue&type=script&lang=js"

import "./Blackjack.vue?vue&type=style&index=0&id=a5b785a2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a5b785a2"]])

export default __exports__